import { Material, Object3D } from "three";

export type json = string | number | boolean | null | json[] | { [key: string]: json };

export interface KeyValue {
  [key: string]: any;
}

export interface MetadataRow {
  readonly id: number;
}

export interface MaterialMap {
  [key: string]: string;
}

export interface MaterialFactory {
  create(name: string): Material;
}

export interface ModelsFactory {
  loadModelPromise(model: MetadataRow): Object3D;
  applyToObject3d(model: MetadataRow, object3d: Object3D);
}

export interface PropertyParameters {
  readonly name: string;

  readonly [key: string]: any;
}

export function assertNotNull(name: string, value: any) {
  if (value == null) throw new Error(name + " is null");
}

export function assertInstanceOf(name: string, value: any, type: any) {
  if (!(value instanceof type)) {
    console.error(name, "is", value, "but expected", type);
    throw new Error(name + " has wrong type");
  }
}
